import React from 'react'

export interface SlctOption {
	value: string | number
	label: string
	disabled?: boolean,
	memo?: boolean
	isGroupLabel?: boolean
}

export enum SlctFormat {
	ValueLabel = 'value - label',
	Value = 'value',
	Label = 'label',
	LabelValue = 'label (value)',
}

export interface SlctProps<Option extends SlctOption> {
	// values
	options: Option[]
	value: string | number | null
	onChange: (newValue: Option | null) => void
	filterOption?: ((option: Option, inputValue: string) => boolean)
	//display
	displayFormat?: SlctFormat,
	showClearButton?: boolean
	// menu
	menuIsOpen?: boolean
	setMenuIsOpen?: () => void
	preventCloseMenuOnSelect?: boolean,
	// state
	disabled?: boolean
	loading?: boolean
	// raw and html attributes
	placeholder?: React.ReactNode | null
	autoFocus?: boolean
	tabIndex?: number
	//custom
	mustMatch?: boolean
	memo?: {
		memoKey: string
		sizeMax?: number
	}
}

export interface SlctInternalProps<Option extends SlctOption> extends SlctProps<Option> {
	inputValue: string
	focus: boolean
	cursor: number | null
	setCursor: (value: number | null) => void
}

export interface SlctOptionProps<Option extends SlctOption> {
	index: number
	option: Option
	selectProps: SlctInternalProps<Option>
}